/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Clear_TimecodesInputs */



/**
* | output |
* | --- |
* | "Clear the timecodes of the selected Events" |
*
* @param {Shortcut_Keys_Desc_Clear_TimecodesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_clear_timecodes = /** @type {((inputs?: Shortcut_Keys_Desc_Clear_TimecodesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Clear_TimecodesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer les timecodes des evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschen Sie die Zeitcodes der ausgewählten Ereignisse.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella i codici temporali degli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить временные метки выбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar los códigos de tiempo de los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除所选事件的时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントのタイムコードをクリアします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट्स के टाइमकोड साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar os códigos de tempo dos eventos selecionados.")
	return /** @type {LocalizedString} */ ("Clear the timecodes of the selected Events")
});